import { render, staticRenderFns } from "./ticket-prices-list.vue?vue&type=template&id=7eff37ec&"
import script from "./ticket-prices-list.vue?vue&type=script&lang=js&"
export * from "./ticket-prices-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports